module.exports = __webpack_public_path__ + "static/logo-6b5b1e5592c3bc30f9744ca8ea7b3e38.png";